module.exports = __webpack_public_path__ + "static/media/hero_tagline_mask.b0e8579e.svg";